/** DO NOT EDIT! **/
/* THIS IS AUTOMATICALLY GENERATED FILE */
/* run update-translations.cjs by npm (see package.json) */

import {TLabels as TBntLabels} from '@binotel-frontend/bnt-common-components';

export {
  AVAILABLE_LANGUAGE_NAMES,
  ELanguages,
  ELocales,
} from '@binotel-frontend/bnt-common-components';
export const BCC_LANGUAGE_PACKS: string[] = ['bcc', 'validation'];

export type TLabels = TBntLabels;
